import { useContext } from 'react';
import CurrentUserContext, { CurrentUserData } from './CurrentUserContext';

function useCurrentUser() {
  const context = useContext<CurrentUserData>(CurrentUserContext);

  if (context === undefined) {
    throw new Error('useCurrentUser: CurrentUserProvider missing');
  }

  return {
    avatar: context.currentUser?.avatar,
    username: context.currentUser?.username,
    isLoggedIn: context.isLoggedIn,
    hasUnreadMessages: context.hasUnreadMessages,
    hasUnreadNotifications: context.hasUnreadNotifications
  };
}

export default useCurrentUser;
